import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.scss";

export default function Sidebar({ user }) {
  const isChris = user?.email === 'chris@siki.io';
  
  return (
    <nav className="adminSidebar">
      <div className="sidebarLogo">SIKI</div>
      <ul>
        <li>
          <NavLink to="/admin/featured" activeClassName="active">Featured</NavLink>
        </li>
        <li>
          <NavLink to="/admin/users" activeClassName="active">Users</NavLink>
        </li>
        <li>
          <NavLink to="/admin/roles" activeClassName="active">Admin Roles</NavLink>
        </li>
        <li>
          <NavLink to="/admin/livestream" activeClassName="active">Livestream</NavLink>
        </li>
        <li>
          <NavLink to="/admin/crypto" activeClassName="active">Crypto</NavLink>
        </li>
        <li>
          <NavLink to="/admin/banners" activeClassName="active">Banners</NavLink>
        </li>
        <li>
          <NavLink to="/admin/reports" activeClassName="active">Reports</NavLink>
        </li>
        <li>
          <NavLink to="/admin/stream-transactions" activeClassName="active">Stream Logs</NavLink>
        </li>
        {isChris && (
          <li>
            <NavLink to="/admin/balance" activeClassName="active">Balance</NavLink>
          </li>
        )}
      </ul>
    </nav>
  );
}